// Tiny TTL helpers for localStorage
// - setWithTTL(key, value, ttlMs): stores value with an expiry timestamp
// - getWithTTL(key, ttlMs?): returns value if not expired; null otherwise
//   If the stored item has its own exp we use that; otherwise we fall back
//   to the ttlMs provided at read-time (useful during transitions).

export function getWithTTL(key, ttlMs) {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const now = Date.now();

        // Prefer stored exp if present
        if (parsed && typeof parsed.exp === "number") {
            if (now > parsed.exp) {
                localStorage.removeItem(key);
                return null;
            }
            return parsed.val;
        }

        // Fallback: if caller supplied ttlMs, synthesize expiry relative to "now"
        if (typeof ttlMs === "number" && ttlMs > 0) {
            // No reliable write-time stored; best we can do is accept it for this session
            // (we won't persist a new exp here)
            return parsed?.val ?? parsed;
        }

        return parsed?.val ?? parsed;
    } catch {
        return null;
    }
}

export function setWithTTL(key, val, ttlMs) {
    try {
        const exp = Date.now() + Math.max(0, Number(ttlMs || 0));
        const payload = { exp, val };
        localStorage.setItem(key, JSON.stringify(payload));
    } catch {
        // Swallow quota or serialization errors
    }
}
